import React from "react";
import Icon from "components/AppIcon";

const weekIcons = ["BookOpen", "Wrench", "Share2", "Users"];
const weekColors = [
  { bg: "#f3f5fd", border: "rgba(40,59,163,0.2)", accent: "var(--color-primary)" },
  { bg: "rgba(211,172,53,0.08)", border: "rgba(211,172,53,0.25)", accent: "var(--color-accent)" },
  { bg: "rgba(40,59,163,0.08)", border: "rgba(40,59,163,0.2)", accent: "var(--color-success)" },
  { bg: "rgba(217,119,6,0.08)", border: "rgba(217,119,6,0.2)", accent: "var(--color-warning)" },
];

const LaunchPlan = ({ weeks }) => {
  return (
    <section className="bg-white rounded-2xl border border-[rgba(40,59,163,0.10)] shadow-sm p-6 md:p-8 lg:p-10">
      <div className="flex items-center gap-3 mb-6">
        <div className="w-10 h-10 md:w-12 md:h-12 rounded-xl flex items-center justify-center flex-shrink-0" style={{ backgroundColor: "rgba(40,59,163,0.08)" }}>
          <Icon name="Map" size={22} color="var(--color-primary)" strokeWidth={2} />
        </div>
        <div>
          <p className="text-xs font-medium uppercase tracking-widest" style={{ color: "var(--color-accent)", fontFamily: "var(--font-caption)" }}>Section 4</p>
          <h2 className="text-xl md:text-2xl lg:text-3xl font-semibold" style={{ fontFamily: "var(--font-heading)", color: "var(--color-foreground)" }}>30-Day Launch Plan</h2>
        </div>
      </div>
      <p className="text-sm md:text-base mb-6" style={{ color: "var(--color-muted-foreground)", fontFamily: "var(--font-body)" }}>
        A practical, week-by-week roadmap. Each step builds on the last. No overwhelm — just clear, sequential actions.
      </p>
      <div className="grid grid-cols-1 md:grid-cols-2 gap-4 md:gap-6">
        {weeks?.map((week, idx) => (
          <div key={idx} className="rounded-xl p-5 border" style={{ backgroundColor: weekColors?.[idx]?.bg, borderColor: weekColors?.[idx]?.border }}>
            <div className="flex items-center gap-3 mb-4">
              <div className="w-9 h-9 rounded-lg flex items-center justify-center flex-shrink-0" style={{ backgroundColor: weekColors?.[idx]?.accent, opacity: 1 }}>
                <Icon name={weekIcons?.[idx]} size={16} color="#fff" strokeWidth={2} />
              </div>
              <div>
                <p className="text-xs font-semibold uppercase tracking-wide" style={{ color: weekColors?.[idx]?.accent, fontFamily: "var(--font-caption)" }}>Week {idx + 1}</p>
                <h3 className="text-sm md:text-base font-bold" style={{ fontFamily: "var(--font-heading)", color: "var(--color-foreground)", fontWeight: 700 }}>{week?.theme}</h3>
              </div>
            </div>
            <ul className="flex flex-col gap-2">
              {week?.tasks?.map((task, tIdx) => (
                <li key={tIdx} className="flex items-start gap-2">
                  <div className="w-5 h-5 rounded-full flex items-center justify-center flex-shrink-0 mt-0.5" style={{ backgroundColor: weekColors?.[idx]?.accent }}>
                    <Icon name="Check" size={10} color="#fff" strokeWidth={3} />
                  </div>
                  <span className="text-sm leading-relaxed" style={{ color: "var(--color-foreground)", fontFamily: "var(--font-body)" }}>{task}</span>
                </li>
              ))}
            </ul>
          </div>
        ))}
      </div>
    </section>
  );
};

export default LaunchPlan;